import React, { memo, useState, useEffect } from 'react';

// import '@style/modules/analysis/analysisRight.scss';
import '../../../../styles/modules/analysis/analysisRight.scss';
import { LEMap } from '@components';
import PowerLink from './powerbiEmbed';
import { combineInfo } from '@components/charts/map/mapDataFormat';
import { useSelector } from 'react-redux';
import CheckboxGroup from './checkboxGroup';
import InfoCards from './infoCards';

const SubsidiariesMap = ({
  data: {
    buyerInfo,
    targetInfo,
    buyerOfficeInfo,
    targetOfficeInfo,
    ...dataSet
  },
  headcount,
  expand,
  handleMapClickCb,
  stateSwitch,
  editButton,
}) => {
  const displayItems = {
    Presence: 'Presence',
    Office: 'Office',
  };

  const [buyerChecked, setBuyerChecked] = useState(true);
  const [targetChecked, setTargetChecked] = useState(true);
  const [buyerInfoSrc, setBuyerInfoSrc] = useState(combineInfo(buyerInfo));
  const [targetInfoSrc, setTargetInfoSrc] = useState(combineInfo(targetInfo));
  const [sharedInfo, setSharedInfo] = useState();
  const [buyerOfficeChecked, setBuyerOfficeChecked] = useState(false);
  const [targetOfficeChecked, setTargetOfficeChecked] = useState(false);
  const [buyerOfficeSrc, setBuyerOfficeSrc] = useState(buyerOfficeInfo);
  const [targetOfficeSrc, setTargetOfficeSrc] = useState(targetOfficeInfo);
  const [displayItem, setDisplayItem] = useState(displayItems.Presence);

  const { buyerLabel, targetLabel, buyerName, targetName } = useSelector(
    ({ common }) => common.projectCompanyInfo,
  );

  useEffect(() => {
    setBuyerInfoSrc(buyerInfo);
    setTargetInfoSrc(targetInfo);
  }, [buyerInfo, targetInfo]);

  const getSharedInfo = () =>
    buyerInfoSrc
      .map((_buyerInfo) => {
        if (targetInfo.length === 0) {
          return null;
        }
        const sharedInfoInTarget = targetInfoSrc.filter(
          (_targetInfo) => _targetInfo.code === _buyerInfo.code,
        );
        if (sharedInfoInTarget.length !== 0) {
          return { buyer: _buyerInfo, target: sharedInfoInTarget[0] };
        }
        return null;
      })
      .filter((x) => x);

  useEffect(() => {
    setBuyerInfoSrc(buyerChecked ? combineInfo(buyerInfo) : []);
  }, [buyerChecked, buyerInfo]);

  useEffect(() => {
    setTargetInfoSrc(targetChecked ? combineInfo(targetInfo) : []);
  }, [targetChecked, targetInfo]);

  useEffect(() => {
    setSharedInfo(getSharedInfo());
  }, [buyerInfoSrc, targetInfoSrc]);

  useEffect(() => {
    if (buyerOfficeChecked) {
      setBuyerOfficeSrc(buyerOfficeInfo);
    } else {
      setBuyerOfficeSrc([]);
    }

    if (targetOfficeChecked) {
      setTargetOfficeSrc(targetOfficeInfo);
    } else {
      setTargetOfficeSrc([]);
    }
  }, [
    buyerOfficeChecked,
    targetOfficeChecked,
    buyerOfficeInfo,
    targetOfficeInfo,
  ]);

  const switchToOffice = (_checked) => {
    setDisplayItem(_checked ? displayItems.Office : displayItems.Presence);
    setBuyerChecked(!_checked);
    setTargetChecked(!_checked);
    setBuyerOfficeChecked(_checked);
    setTargetOfficeChecked(_checked);
  };

  const isDisplayPresence = displayItem === displayItems.Presence;

  return (
    <div className="subs-bottom-wrapper subs-map-wrapper">
      {stateSwitch}
      {editButton}
      <PowerLink />
      <div className="switches-and-squares">
        <CheckboxGroup
          {...{
            expand,
            isDisplayPresence,
            onPresenceOfficeSwitchChange: switchToOffice,
            buyerLabel,
            targetLabel,
            buyerChecked,
            targetChecked,
            setBuyerChecked,
            setTargetChecked,
            buyerOfficeChecked,
            targetOfficeChecked,
            setBuyerOfficeChecked,
            setTargetOfficeChecked,
          }}
        />
        <InfoCards
          {...{
            expand,
            buyerLabel,
            targetLabel,
            displayItem,
            ...dataSet,
          }}
          headcount={headcount}
        />
      </div>
      {isDisplayPresence ? (
        <div className="hint">
          Click the map to see corresponding LE subsidiaries detail of that
          country.
        </div>
      ) : null}
      <LEMap
        buyerInfo={buyerInfoSrc}
        targetInfo={targetInfoSrc}
        sharedInfo={sharedInfo}
        expand={expand}
        handleMapClickCb={handleMapClickCb}
        buyerLabel={buyerLabel}
        targetLabel={targetLabel}
        buyerOffices={buyerOfficeSrc}
        targetOffices={targetOfficeSrc}
        buyerName={buyerName}
        targetName={targetName}
      />
      <div className="map-legend">
        <div className="yellow square" />
        {buyerLabel}
        <div className="blue square" />
        {targetLabel}
        {buyerChecked && targetChecked ? (
          <>
            <div className="orange square" />
            Shared
          </>
        ) : null}
      </div>
      <p className="sub-info-text">
        <i>
          <div>
            <span>*</span> LE Subsidiary data is sourced from Dow Jones, and
            office location data is sourced from publicly available information
          </div>
          <div>
            <span>†</span> Country count for LE presence reflects subsidiaries
            and does not include branches
          </div>
          <div>
            <span>‡</span> All currency figures are reported in $ 000&apos;s.
          </div>
          <div>
            <span>§</span> Employee headcount figures sourced from Dow Jones and
            may reflect different figures from reported headcount.
          </div>
        </i>
      </p>
    </div>
  );
};

export default memo(SubsidiariesMap);
